/**
 * `useCapabilityAllowed`: the hook surfaces call to gate an affordance by the
 * active member's membership state (028-membership-state-gating).
 *
 * Contract: `specs/028-membership-state-gating/contracts/capability-gating.md`.
 * Research Decision 3: surfaces read this hook (which composes
 * `useMembershipStatus` + the matrix), never branching on `MembershipStatus`
 * directly to make their own decision.
 */

import { type Capability, isCapabilityAllowed } from './capabilities.js';
import { useMembershipStatus } from './useMembershipStatus.js';

/**
 * Is the capability active for the current member? `true` only for `allowed`;
 * both `greyed` and `not_applicable` are not active. Use for enable/disable
 * and mount/skip decisions.
 */
export function useCapabilityAllowed(capability: Capability): boolean {
  const status = useMembershipStatus();
  return isCapabilityAllowed(status, capability);
}
